<ngb-alert *ngIf="!staticAlertClosed" (close)="staticAlertClosed = true">
  {{text}}
</ngb-alert>
